import React from 'react';
import './css/footer-note.css';
import { useTranslation } from '../hooks/useTranslation';

const FooterNote = () => {
  const { language } = useTranslation();

  const isArabic = language === 'ar';

  return (
    <div className="footer-note">
      {isArabic ? (
        <p className="footer-note-text arabic">
          تم تطوير هذا الموقع بواسطة فريق بروز. جميع الحقوق محفوظة. © 2025 BROS
        </p>
      ) : (
        <p className="footer-note-text english">
          © 2025 BROS. This website was developed by the BROS team. All rights reserved.
        </p>
      )}
    </div>
  );
};

export default FooterNote;

